<template>
    <transition name="layout-fade">
        <loader v-if="loading"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Просмотр статистики для букинга</v-toolbar-title>
                <v-spacer/>
                <v-btn icon :loading="loading" :disabled="loading" @click="closeLayout">
                    <v-icon>close</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-layout>
                        <v-subheader class="headline pa-0">Общее</v-subheader>
                    </v-layout>
                    <v-layout>
                        <v-flex xs3>
                            <v-subheader class="pa-0">Общее кол-во бронирований:</v-subheader>
                            <b>{{ booking.all | formatPrice }}</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs3>
                            <v-subheader class="pa-0">Успешных:</v-subheader>
                            <b>{{ booking.success | formatPrice }}</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs3>
                            <v-subheader class="pa-0">Отмененных:</v-subheader>
                            <b>{{ booking.failure | formatPrice }}</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs3>
                            <v-subheader class="pa-0">В процессе:</v-subheader>
                            <b>{{ booking.in_progress | formatPrice }}</b>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-subheader class="headline pa-0 mt-5">Платформы</v-subheader>
                    </v-layout>
                    <v-layout>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Мобильные приложения (iOs/Android):</v-subheader>
                            <b>{{ booking.mobile | formatPrice }}</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Через telegram_bot:</v-subheader>
                            <b>{{ booking.tg | formatPrice }}</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Сайт:</v-subheader>
                            <b>{{ booking.site | formatPrice }}</b>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-subheader class="headline pa-0 mt-5">По залам</v-subheader>
                    </v-layout>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Детский:</v-subheader>
                            <b>{{ booking.hall_kids | formatPrice }}</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Терасса:</v-subheader>
                            <b>{{ booking.hall_terrace | formatPrice }}</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Общий:</v-subheader>
                            <b>{{ booking.hall_common | formatPrice }}</b>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-subheader class="headline pa-0 mt-5">Гости</v-subheader>
                    </v-layout>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Общее количество посищений</v-subheader>
                            <b>{{ booking.guest_count | formatPrice }}</b>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Максимальное количество гостей за одно бронирование</v-subheader>
                            <b>{{ booking.guest_max | formatPrice }}</b>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Statistic from '../../../api/statistic'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'statisticBooking',
        components: { Loader },
        data: () => ({
            loading: false,
            booking: {
                all: 0,
                success: 0,
                failure: 0,
                in_progress: 0,
                mobile: 0,
                tg: 0,
                site: 0,
                hall_kids: 0,
                hall_terrace: 0,
                hall_common: 0,
                guest_count: 0,
                guest_max: 0
            }
        }),
        mounted () {
            this.loading = true

            Statistic
                .getBookingStat()
                .then(response => this.booking = response.data.data)
                .catch(error => new Error(error))
                .finally(() => this.loading = false)
        },
        methods: {
            closeLayout () {
                this.$router.push({ name: 'headBlankIndex' })
            }
        }
    }
</script>
